import { Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const Discount = ({ name, amount, upTo }) => {
  const { t } = useTranslation();

  return (
    <Row between noFlex center marg="0 0 16px">
      <Text b2 col={theme.GREY_60}>
        {name}
      </Text>

      <Row noFlex bg={theme.SECONDARY} pad="2px 8px" minWid="67px" centerAll>
        <Text c1 bold col="#fff">
          {t(upTo ? 'subscribe.upToOff' : 'subscribe.off', { amount })}
        </Text>
      </Row>
    </Row>
  );
};

export default Discount;
